import React, { ReactNode } from "react";
import { OwnerType } from "./types";

interface AdminContextType {
  admin: OwnerType;
}

export const AdminContext = React.createContext({} as AdminContextType);

interface AdminProviderProps {
  admin: OwnerType;
  children: ReactNode;
}

export default function AdminProvider(
  props: AdminProviderProps,
): React.JSX.Element {
  return (
    <AdminContext.Provider value={{ admin: props.admin }}>
      {props.children}
    </AdminContext.Provider>
  );
}
